import React from 'react';
import createReactClass from 'create-react-class';
import Reflux from 'reflux';

import configurationStore from '../stores/configuration-store';
import facetStore from '../stores/facet-store';
import itemStore from '../stores/item-store';

import CtxContent from './CtxContent';
import Contact, {numPages as contactNumPages} from './Contact';
import Cover, {numPages as coverNumPages} from './Cover';
import Mounting, {numPages as mountingNumPages} from './Mounting';
import Planning, {numPages as planningNumPages} from './Planning';
import Safety, {numPages as safetyNumPages} from './Safety';
import Variants, {numPages as variantsNumPages} from './Variants';

const CALC_PAGE_NUM_FNS = [
	['cover', coverNumPages],
	['safety', safetyNumPages],
	['variants', variantsNumPages],
	['planning', planningNumPages],
	['mounting', mountingNumPages, 'no'],
	['contact', contactNumPages],
];

export default createReactClass({
	displayName: 'MountingRoot',

	mixins: [
		Reflux.listenTo(facetStore, 'onFacetChange', 'onFacetChange'),
		Reflux.listenTo(itemStore, 'onItemChange', 'onItemChange'),
		Reflux.listenTo(configurationStore, 'onConfigurationChange')
	],

	getInitialState() {
		return {
			facets: {},
			content: {},
			pageNums: CALC_PAGE_NUM_FNS.reduce(
				(acc, [key, _, arri]) => {
					acc[key] = arri ? [] : 0;
					return acc;
				},
				{}
			),
			maxPageNum: 0,
		};
	},

	onFacetChange(newState) {
		this.onChange(newState);
	},
	onItemChange(newState) {
		this.onChange(newState);
	},
	onConfigurationChange(newState) {
		this.onChange(newState);
	},
	onChange(newState) {
		const newStateFull = Object.assign({}, this.state, newState);
		let lastEnd = 1;
		const pageNums = {};
		CALC_PAGE_NUM_FNS
			.forEach(([key, func, array]) => {
				const pageNum = func(newStateFull);
				if (array) {
					pageNums[key] = [];
					pageNum.forEach((num, i) => {
						pageNums[key][i] = lastEnd;
						lastEnd += num;
					});
				} else {
					pageNums[key] = lastEnd;
					lastEnd += pageNum;
				}
			});
		newState.maxPageNum = lastEnd - 1;
		newState.pageNums = pageNums;
		this.setState(newState);
	},

	render() {
		const {facets, items, content, pageNums, maxPageNum} = this.state;
		const {mounting = []} = content;
		return (
			<CtxContent.Provider value={content}>
				<div className="slx-mounting">
					<Cover
						facets={facets}
						content={content}
						startPageNumber={pageNums.cover}
						maxPageNumber={maxPageNum}
						/>

					<Safety
						facets={facets}
						content={content}
						startPageNumber={pageNums.safety}
						maxPageNumber={maxPageNum}
						/>

					<Variants
						facets={facets}
						items={items}
						content={content}
						startPageNumber={pageNums.variants}
						maxPageNumber={maxPageNum}
						/>

					<Planning
						content={content}
						startPageNumber={pageNums.planning}
						maxPageNumber={maxPageNum}
						/>

					{mounting.map((m, index) => (
						<Mounting
							content={content}
							mounting={m}
							key={index}
							startPageNumber={pageNums.mounting[index]}
							maxPageNumber={maxPageNum}
						/>
					))}

					<Contact
						content={content}
						startPageNumber={pageNums.contact}
						maxPageNumber={maxPageNum}
					/>

				</div>
			</CtxContent.Provider>
		);
	},
});
